import { render } from "./ProfileInfo.vue?vue&type=template&id=468dd017&scoped=true&ts=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts"

import "./ProfileInfo.vue?vue&type=style&index=0&id=468dd017&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468dd017"]])

export default __exports__